import './DistroPage.scss'
import {useSelector} from "react-redux";
import DistroHistoryChart from "./DistroHistoryChart.jsx";
import {getAllAssets} from "../../ducks/assets-duck.js";
import {aggregateAssetsDistro} from "./_helpers.js";
import Counter from "../util/Counter.jsx";
import {DECIMAL_FORMAT} from "../../util/numbers.js";
import DonutChart from "../util/donut/DonutChart.jsx";
import {DONUT_DUAL_VALUES_COLORS} from "../util/donut/_colors.js";

export default () => {

    const assets = useSelector(getAllAssets)

    const {
        companyValue,
        privateValue,
        totalValue,
        groups = [],
    } = aggregateAssetsDistro(assets)

    const groupData = Object.values(groups).map(group => ({value: group.totalValue, label: group.groupKey}))

    return (
        <div className='distro-page'>
            <h2>
                Portfolio Distribution
            </h2>
            <div className='all-groups flex-vertical-center'>
                <DonutChart
                    data={groupData}
                    size={180}
                    thickness={12}
                />
                <DonutChart
                    values={[privateValue, companyValue]}
                    labels={['private', 'company']}
                    size={180}
                    thickness={12}
                    colors={DONUT_DUAL_VALUES_COLORS}
                />
            </div>
            <DistroHistoryChart/>
            <div className='group-ownership-distro'>
                {Object.values(groups).map(({companyValue, privateValue, groupKey}) =>
                    <div className='group'>
                        <DonutChart
                            values={[privateValue, companyValue]}
                            labels={['private', 'company']}
                            size={140}
                            thickness={9}
                            colors={DONUT_DUAL_VALUES_COLORS}
                        >
                            <h3 className='flex-vertical-center'>
                                <div>
                                    {groupKey}
                                </div>
                                <div className='small'>
                                    <Counter
                                        amount={(companyValue + privateValue) / totalValue * 100}
                                        decimals={DECIMAL_FORMAT.FLEX_PERCENTAGE}
                                        suffix='%'
                                    />
                                </div>
                            </h3>
                        </DonutChart>
                    </div>
                )}
            </div>
            {/*<JSONPretty data={restOfAggregate} />*/}
            {/*<JSONPretty data={assetsOrdered} />*/}
        </div>
    )
}